import { format, parseISO } from 'date-fns';

export const getOneSmallerDate = (date: Date) => {
  date.setDate(date.getDate() - 1);
  return date;
};

export const getOneBiggerDate = (date: Date) => {
  date.setDate(date.getDate() + 1);
  return date;
};

export const getTomorowsDate = () => {
  const date = new Date();
  return getOneBiggerDate(date);
};

export function formatDate(date_string: string) {
  const date = new Date(date_string);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
  // return date_string;
}

export function getNextMonthFirstDay(dateString: string) {
  // Parse the input date string into a Date object
  const date = new Date(dateString);

  // Get the current month and year
  const currentMonth = date.getMonth();
  const currentYear = date.getFullYear();

  // Calculate the next month and year
  let nextMonth = currentMonth + 1;
  let nextYear = currentYear;
  if (nextMonth > 11) {
    nextMonth = 0;
    nextYear += 1;
  }

  // Create a new Date object for the first day of the next month
  const nextMonthFirstDay = new Date(nextYear, nextMonth, 1);

  return nextMonthFirstDay;
}

export function getFirstDayOfMonth(dateString: string) {
  // Parse the input date string into a Date object
  const date = new Date(dateString);

  // Get the current month and year
  const currentMonth = date.getMonth();
  const currentYear = date.getFullYear();
  // Create a new Date object for the first day of the current month
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
  return firstDayOfMonth;
}

export function getFirstDayFromDateString(dateString: string) {
  const arr = dateString.split('-');
  // Get the current month and year
  const currentMonth = parseInt(arr[1]) - 1;
  const currentYear = parseInt(arr[0]);

  // Create a new Date object for the first day of the current month
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
  return firstDayOfMonth;
}

export function getLastDayOfMonth(dateString: string) {
  // Parse the input date string into a Date object
  const date = new Date(dateString);

  // Get the current month and year
  const currentMonth = date.getMonth();
  const currentYear = date.getFullYear();

  // Calculate the last day of the current month
  const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0);

  return lastDayOfMonth;
}

export function convertIsoToDateString(isoString: string): string | null {
  try {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const twelveHourFormat = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours; //Handle 12 AM/PM

    return `${year}/${month}/${day} ${twelveHourFormat}:${minutes} ${ampm}`;
  } catch (error) {
    return null; // Or throw the error, depending on your error handling preference.
  }
}

export const convertPlanningPeriodArray = (dates: string[]): { label: string; code: string }[] => {
  const result = dates.map(date => {
    const [year, month, day] = date.split('-');
    const dateObj = new Date(Number(year), Number(month) - 1, Number(day));
    const startMonth = new Date(dateObj.setMonth(dateObj.getMonth() + 1)).toLocaleString(
      'default',
      { month: 'short' }
    );
    const startYear = dateObj.getFullYear();

    const endDate = new Date(dateObj.setMonth(dateObj.getMonth() + 11));
    const endYear = endDate.getFullYear();
    const endMonth = endDate.toLocaleString('default', { month: 'short' });
    return {
      label: `${startMonth} ${startYear} - ${endMonth} ${endYear}`,
      code: date
    };
  });
  return result;
};

export const getCurrentMonthDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = '01'; // First day of the month
  return `${year}-${month}-${day}`;
};

export function tConvert(time: string) {
  // Check correct time format and split into components
  let updatedTime: string | string[] = time
    .toString()
    .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (updatedTime.length > 1) {
    // If updatedTime format correct
    updatedTime = updatedTime.slice(1); // Remove full string match value
    updatedTime[5] = +updatedTime[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
    updatedTime[0] = +updatedTime[0] % 12 || 12; // Adjust hours
  }
  return updatedTime.join(''); // return adjusted time or original string
}

// PPS utils

export const formatDateForDisplay = (dateValue: Date, includeTime = true) => {
  try {
    // Check if the input is valid
    if (!dateValue) {
      return '';
    }

    // Parse the ISO date string to a Date object
    const date = typeof dateValue === 'string' ? parseISO(dateValue) : dateValue;

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return '';
    }

    // Format based on whether time should be included
    if (includeTime) {
      // Format with time: MM-dd-yyyy hh:mm a
      return format(date, 'MM-dd-yyyy hh:mm a');
    } else {
      // Format date only: MM-dd-yyyy
      return format(date, 'MM-dd-yyyy');
    }
  } catch (error) {
    return '';
  }
};

export const getDate = () => {
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}-${year}`;
};

export const getDateWithTime = () => {
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // Convert to 12-hour format
  const hour12 = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const ampm = hours >= 12 ? 'PM' : 'AM';

  const formattedDate = `${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}-${year}`;
  const formattedTime = `${hour12 < 10 ? '0' + hour12 : hour12}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds} ${ampm}`;

  return `${formattedDate} ${formattedTime}`;
};
